// extracted by mini-css-extract-plugin
export default {"textMargin":"app-core-components-Tip-TextTip-TextTip-module__text-margin"};